import Styles from '../ReviewTemplateForm.module.scss'
import { FormikTextInputField } from 'components/Form/TextInputField'
import { notEmpty } from '../utils'

interface Props {
  isDisabled: boolean
}

export const NameField = ({ isDisabled }: Props) => (
  <>
    <label className={Styles.label} htmlFor="name">
      Name
    </label>
    <FormikTextInputField
      name="name"
      wrapperClassName={Styles.input}
      id="name"
      size="xl"
      placeholder="Name your template"
      validate={notEmpty}
      disabled={isDisabled}
      aria-label="Name"
      autoFocus
    />
  </>
)
